import Vue from 'vue'

const HeaderComponent = Vue.component('HeaderComponent', {
    data: function () {
      return {
          status: 'all'
      }
    },

    mounted () {
        console.log('this.params', this.params)
    },

    watch: {
        status () {
            console.log('this.params.context.componentParent', this.params.context.componentParent)
        }
    },
    methods: {
    },
    template: '<select v-model="status"><option value="all">상태전체</option><option value="proceed">진행중</option><option value="end">종료</option></select>'
  })

  const PreviewComponent = Vue.component('PreviewComponent', {
    data: function () {
      return {

      }
    },

    mounted () {
        console.log('this.params', this.params)
    },

    watch: {
        status () {
            console.log('this.params.context.componentParent', this.params.context.componentParent)
        }
    },
    methods: {
        preview () {
            console.log(312123231)
        }
    },
    template: '<a @click="preview()" style="cursor: pointer; text-decoration:underline; color: blue;">미리보기</a>'
  })

  const AddComponent = Vue.component('AddComponent', {
    data: function () {
      return {

      }
    },

    mounted () {
        console.log('this.params', this.params)
    },

    watch: {
        status () {
            console.log('this.params.context.componentParent', this.params.context.componentParent)
        }
    },
    methods: {
        add () {
            console.log(312123231)
        }
    },
    template: '<a @click="add()" style="cursor: pointer; color: blue;">추가</a>'
  })

  
  const MoveApplyListComponent = Vue.component('MoveApplyListComponent', {
    data: function () {
      return {
          
      }
    },
    mounted () {
        console.log('this.params', this.params)
    },
    methods: {  
        moveApplyList () {
            this.$router.push('/admin/list/applyList')
        }
    },

    template: '<div style="cursor:pointer" @click="moveApplyList()">{{params.value}}</div>'
  })
  

  const ApplyStatusComponent = Vue.component('ApplyStatusComponent', {
    data: function () {
      return {
          status: 'wait'
      }
    },

    watch: {
        status () {
            console.log('this.params.context.componentParent', this.params.context.componentParent)
        }
    },

    template: '<select v-model="status"><option value="wait">대기상태</option><option value="complete">신청완료</option></select>'
  })

  const PayStatusComponent = Vue.component('PayStatusComponent', {
    data: function () {
      return {
          status: 'complete'
      }
    },

    watch: {
        status () {
            console.log('this.params.context.componentParent', this.params.context.componentParent)
        }
    },

    template: '<select v-model="status"><option value="complete">결제완료</option><option value="incomplete">미결제</option><option value="none">결제없음</option></select>'
  })



export {
    AddComponent,
    HeaderComponent,
    PreviewComponent,
    MoveApplyListComponent,
    ApplyStatusComponent,
    PayStatusComponent
  }
  